module.exports = __webpack_public_path__ + "static/media/up-arrow-svgrepo-com (11).b504482a.svg";